import React from 'react';
import styled from 'styled-components';
import { palette } from '@m12s/component-library';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getSelectWorkOrderOpOptions } from 'lib/selectors/getSelectWorkOrderOp';
import PropTypes from 'prop-types';
import JobCard from './JobCard';

const SearchRootContainer = styled.div`
  padding: 1.5rem;
  height: fit-content;
`;

const StandardRootContainer = styled.div`
  padding: 1.5rem;
  height: 100%;
  /* Width based on content or fixed value */
  width: auto; /* or e.g. width: 200px; */
  flex-shrink: 0;
`;

const SearchNextWorkOrderCardContainer = styled.div`
  position: relative;
  background-color: ${palette.White};
  border: 1px solid ${palette.Indigo600};
  border-radius: 0.5rem;
  height: fit-content;
`;

const StandardNextWorkOrderCardContainer = styled.div`
  position: relative;
  background-color: ${palette.White};
  border: 1px solid ${palette.Indigo600};
  border-radius: 0.5rem;
  height: 100%;
`;

const NextWorkOrderCardText = styled.span`
  position: absolute;
  top: 0;
  right: 0;
  background-color: ${palette.Indigo600};
  color: ${palette.White};
  padding: 0.5rem 0.625rem;
  border-radius: 0 0.5rem 0 0.5rem;
  font-size: 1rem;
  font-weight: 700;
`;

const HeaderText = styled.h5`
  font-size: 0.75rem;
  line-height: 0.75rem;
  font-weight: 700;
  color: ${palette.Grey700};
`;

const NextWorkOrderOpCard = ({ workOrderOp, nextStep, dispatch }) => {
  const { t } = useTranslation();
  const { isSearchMode } = useSelector(getSelectWorkOrderOpOptions);

  const RootContainer = isSearchMode
    ? SearchRootContainer
    : StandardRootContainer;

  const NextWorkOrderCardContainer = isSearchMode
    ? SearchNextWorkOrderCardContainer
    : StandardNextWorkOrderCardContainer;

  const { workOrder } = workOrderOp || {};

  return (
    <RootContainer isSearchMode={isSearchMode}>
      {isSearchMode && <HeaderText>{t('Next Job').toUpperCase()}</HeaderText>}
      <NextWorkOrderCardContainer isSearchMode={isSearchMode}>
        <JobCard
          workOrderOp={workOrderOp}
          nextStep={nextStep}
          dispatch={dispatch}
          key={`${workOrder?.workOrderId}-${workOrder?.partNumber}-${workOrderOp?.sequenceNumber}`}
        />
        {!isSearchMode && (
          <NextWorkOrderCardText>
            {t('Next').toUpperCase()}
          </NextWorkOrderCardText>
        )}
      </NextWorkOrderCardContainer>
    </RootContainer>
  );
};

NextWorkOrderOpCard.propTypes = {
  workOrderOp: PropTypes.object.isRequired,
  nextStep: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default NextWorkOrderOpCard;
